import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';

// Componentes
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Monitoreo from './pages/Monitoreo';
import Conjuntos from './pages/Conjuntos';
import UsuariosAdminPage from './pages/UsuariosAdminPage';

// Context y protección
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import './App.css';

function App() {
  return (
    <ConfigProvider locale={esES}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Ruta de login */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Redirección raíz */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            {/* Rutas protegidas */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/monitoreo" element={
              <ProtectedRoute>
                <Layout>
                  <Monitoreo />
                  </Layout>
                </ProtectedRoute>
              } />
            
            <Route path="/conjuntos" element={
              <ProtectedRoute>
                <Layout>
                  <Conjuntos />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/usuarios-admin" element={
              <ProtectedRoute>
                <Layout>
                  <UsuariosAdminPage />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Ruta catch-all */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;